import { Navigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { HOMEPAGE_JSON_LD } from "../../seo/structuredData";
import "./Homepage.css";
import LandingNav from "./sections/LandingNav";
import HeroSection from "./sections/HeroSection";
import ProofBar from "./sections/ProofBar";
import EvaluationSection from "./sections/EvaluationSection";
import QuizSection from "./sections/QuizSection";
import OnlineTestsSection from "./sections/OnlineTestsSection";
import DashboardSection from "./sections/DashboardSection";
import HowItWorks from "./sections/HowItWorks";
import TeacherFeaturesSection from "./sections/TeacherFeaturesSection";
import PricingSection from "./sections/PricingSection";
import TestimonialsSection from "./sections/TestimonialsSection";
import ClosingSection from "./sections/ClosingSection";
import LandingFooter from "./sections/LandingFooter";

function Homepage() {
  // Legacy link support: old bookmarks / external links point at
  // /#request-demo. That hash used to scroll to the final CTA on the
  // single-page landing; now the demo form lives on its own route, so
  // forward those links to /request-demo before anything else renders.
  // Checked synchronously on every render so it fires on initial load
  // (no useEffect timing gap) and strips the hash from the URL.
  if (typeof window !== "undefined" && window.location.hash === "#request-demo") {
    return <Navigate to="/request-demo" replace />;
  }

  return (
    <div className="unchay-landing">
      {/*
        Helmet on the landing route is intentionally minimal. Every meta tag
        on this page (title, description, canonical, og:*, twitter:*) is set
        statically in `index.html` so non-JS crawlers see them on the initial
        fetch. Duplicating them here caused Bing to flag "More than one Meta
        Description tag" / "More than one canonical tag" because Helmet
        APPENDS to <head> rather than replacing static tags. Keep only the
        JSON-LD structured data here — it's the one thing the static HTML
        doesn't carry.
        For OTHER routes (RequestDemo, Privacy, etc.) Helmet still sets a
        per-page title/description; if Bing ever flags duplicates on those,
        we'll need to strip the static tags on mount or add per-route
        Helmet management. See docs/BUG-FIX-LOG.md (2026-05-20 entry).
      */}
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(HOMEPAGE_JSON_LD)}</script>
      </Helmet>
      <LandingNav />
      <main id="main">
        <HeroSection />
        <ProofBar />
        <EvaluationSection />
        <QuizSection />
        <OnlineTestsSection />
        <DashboardSection />
        <HowItWorks />
        <TeacherFeaturesSection />
        <TestimonialsSection />
        <PricingSection />
        <ClosingSection />
      </main>
      <LandingFooter />
    </div>
  );
}

export default Homepage;
